import React, { useEffect } from 'react';
import DynamicComponents from '../components/DynamicComponents';
import { storyblokEditable, useStoryblokState } from 'gatsby-source-storyblok';
import Layout from '@/components/layout';
import { IBlok } from '../types';
import Seo, { SeoProps } from '@/components/core/Seo/seo';
import { Script } from 'gatsby';
import findAndStoreUtmTags from '../helpers/findAndStoreUTMTags';
import useSiteSettingsData from '../data/useSiteSettingsData';

interface PageProps {
  location: any;
  pageContext: {
    full_slug: string;
    slug: string;
    content: {
      body: IBlok[];
      SEO: SeoProps;
    };
  };
  path: string;
}

const Page: React.FC<PageProps> = ({ pageContext, location }) => {
  let story: any = pageContext;
  story = useStoryblokState(story, {
    resolveRelations: [
      'selected-posts.posts',
      'global-reference.reference',
      'configurator-summary.product',
      'configurator-confirmed.product',
    ],
    language: location,
  });

  const content =
    story?.content.body &&
    story.content.body.map((childBlok: IBlok) => {
      return (
        <div {...storyblokEditable(childBlok)} key={childBlok._uid}>
          <DynamicComponents blok={childBlok} key={childBlok._uid} />
        </div>
      );
    });

  useEffect(() => {
    findAndStoreUtmTags();
  }, []);

  return (
    <Layout
      location={location}
      headerSettings={{
        text_color: story.content.header_text_color,
        position: story.content.header_position,
        banner: story.content.banner,
      }}
    >
      {content}
    </Layout>
  );
};

export default Page;

export function Head({
  pageContext,
  location: { pathname },
}: {
  pageContext: { full_slug: string; slug: string; content: { SEO: SeoProps } };
  location: { pathname: string };
}) {
  const location = pageContext.slug === 'home' ? '' : pageContext.full_slug;
  const siteData = useSiteSettingsData({ pathname });

  return (
    <>
      <Seo
        {...pageContext.content.SEO}
        location={location}
        lang={siteData.slug}
      />
      ;
      <Script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script="dec582d7-8b0e-419f-9800-a8255d2cde9d"
        async
      ></Script>
      <Script
        dangerouslySetInnerHTML={{
          __html: `
            function OptanonWrapper() {
    
            }
          `,
        }}
      ></Script>
    </>
  );
}
